import React, { FC } from 'react';
import { TabletLoginInfoWrapper } from './TabletLoginInfoWrapper';
import { BackgroundImage, Padding4Rem, RoundedPaper } from './Atoms';
import { PublicPagesInfo } from './PublicPagesInfo';
import { Theme, styled } from '@material-ui/core';

type PublicPagesInfoWrapperProps = {
  mobile: boolean;
  tablet: boolean;
  backendOnline?: boolean;
};

const Wrapper = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.primary.dark,
  '&.is-tablet': {
    backgroundColor: theme.palette.common.white,
  },
}));

export const PublicPagesInfoWrapper: FC<PublicPagesInfoWrapperProps> = ({
  mobile,
  tablet,
  backendOnline = true,
}) => (
  <Wrapper className={tablet ? 'is-tablet' : undefined}>
    {tablet ? (
      <TabletLoginInfoWrapper mobile={mobile} />
    ) : (
      <Padding4Rem>
        <BackgroundImage />
        {backendOnline && (
          <RoundedPaper>
            <PublicPagesInfo />
          </RoundedPaper>
        )}
      </Padding4Rem>
    )}
  </Wrapper>
);
